export var valuesPowerBiObjectTypeEnum = ["Report", "Dashboard", "Visual"];
/*

*/ 
//# sourceMappingURL=PowerBiObjectTypeEnum.js.map